import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelCostService', HotelCostService);

  HotelCostService.$inject = ['RestResource', '$translate', '$filter', 'UtilService'];

  function HotelCostService(RestResource, $translate, $filter, UtilService) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotels';

    var service = {
      searchHotelCosts: searchHotelCosts,
      saveHotelCosts: saveHotelCosts,
    };

    return service;

    ////////////////

    function searchHotelCosts(hotel, filterCriteria) {
      var url = apiUrl + '/' + hotel.id + '/hotel_costs';

      if (!filterCriteria) {
        filterCriteria = {};
      }

      filterCriteria.company_id = hotel.company_id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveHotelCosts(hotel, params, editMode) {
      var url = apiUrl + '/' + hotel.id + '/hotel_costs';

      params.company_id = hotel.company_id;
      params.option = !editMode ? 'create' : 'update';

      function success(response) {
        var msg = !editMode ? 'COSTS_ADDED' : 'UPDATED_COSTS';
        utils._successMsg($translate(msg));

        return response.data;
      }
      function failure(response) {
        utils.openModalError(response.data.error);

        return false;
      }

      return RestResource.request('post', url, params, success, failure);
    }
  }
})();
